import {
    CreatePurchaseProcessUseCase,
    GetPurchaseProcessAuditUseCase,
    GetPurchaseProcessByIdUseCase,
    GetPurchaseProcessesUseCase,
    GetPurchasingStagesUseCase,
    GetSourceContextUseCase,
    UpdatePurchaseProcessAssigneeUseCase,
    UpdatePurchaseProcessStageUseCase,
    UpdatePurchaseProcessStatusUseCase,
    UpdatePurchaseProcessUseCase,
    GetSupplierQuotesUseCase,
    CreateSupplierQuoteUseCase,
    UpdateSupplierQuoteUseCase,
    UpdateSupplierQuoteStatusUseCase,
    SelectSupplierQuoteUseCase,
    DeleteSupplierQuoteUseCase,
    GetPurchasingSuppliersUseCase,
    SearchPurchasingSuppliersUseCase,
    CreatePurchasingSupplierUseCase,
    UpdatePurchasingSupplierUseCase,
    GetPurchasePreparationUseCase,
    CreateProcessesBatchUseCase,
    GetPurchaseByProcessUseCase,
    CreatePurchaseUseCase,
    UpdatePurchaseUseCase,
    ChangePurchaseStatusUseCase,
    GetPurchaseFinanceUseCase,
    CreatePurchasePaymentUseCase,
    UpdatePurchasePaymentUseCase,
    MarkPurchasePaymentPaidUseCase,
    CancelPurchasePaymentUseCase,
    GetProcessAttachmentsUseCase,
    InitiateAttachmentUseCase,
    CompleteAttachmentUseCase,
    UpdateAttachmentUseCase,
    DeleteAttachmentUseCase,
    GetProductionLinksUseCase,
    ConfirmProductionLinkUseCase,
    UnlinkProductionLinkUseCase,
    RefreshProductionUseCase,
} from '@Purchasing/Domain/UseCases'
export const Register = {
    UseCaseGetPurchaseProcesses: GetPurchaseProcessesUseCase,
    UseCaseGetPurchaseProcessById: GetPurchaseProcessByIdUseCase,
    UseCaseCreatePurchaseProcess: CreatePurchaseProcessUseCase,
    UseCaseUpdatePurchaseProcess: UpdatePurchaseProcessUseCase,
    UseCaseUpdatePurchaseProcessStatus: UpdatePurchaseProcessStatusUseCase,
    UseCaseUpdatePurchaseProcessStage: UpdatePurchaseProcessStageUseCase,
    UseCaseUpdatePurchaseProcessAssignee: UpdatePurchaseProcessAssigneeUseCase,
    UseCaseGetPurchaseProcessAudit: GetPurchaseProcessAuditUseCase,
    UseCaseGetPurchasingStages: GetPurchasingStagesUseCase,
    UseCaseGetSourceContext: GetSourceContextUseCase,
    UseCaseGetSupplierQuotes: GetSupplierQuotesUseCase,
    UseCaseCreateSupplierQuote: CreateSupplierQuoteUseCase,
    UseCaseUpdateSupplierQuote: UpdateSupplierQuoteUseCase,
    UseCaseUpdateSupplierQuoteStatus: UpdateSupplierQuoteStatusUseCase,
    UseCaseSelectSupplierQuote: SelectSupplierQuoteUseCase,
    UseCaseDeleteSupplierQuote: DeleteSupplierQuoteUseCase,
    UseCaseGetPurchasingSuppliers: GetPurchasingSuppliersUseCase,
    UseCaseSearchPurchasingSuppliers: SearchPurchasingSuppliersUseCase,
    UseCaseCreatePurchasingSupplier: CreatePurchasingSupplierUseCase,
    UseCaseUpdatePurchasingSupplier: UpdatePurchasingSupplierUseCase,
    UseCaseGetPurchasePreparation: GetPurchasePreparationUseCase,
    UseCaseCreateProcessesBatch: CreateProcessesBatchUseCase,
    UseCaseGetPurchaseByProcess: GetPurchaseByProcessUseCase,
    UseCaseCreatePurchase: CreatePurchaseUseCase,
    UseCaseUpdatePurchase: UpdatePurchaseUseCase,
    UseCaseChangePurchaseStatus: ChangePurchaseStatusUseCase,
    UseCaseGetPurchaseFinance: GetPurchaseFinanceUseCase,
    UseCaseCreatePurchasePayment: CreatePurchasePaymentUseCase,
    UseCaseUpdatePurchasePayment: UpdatePurchasePaymentUseCase,
    UseCaseMarkPurchasePaymentPaid: MarkPurchasePaymentPaidUseCase,
    UseCaseCancelPurchasePayment: CancelPurchasePaymentUseCase,
    UseCaseGetProcessAttachments: GetProcessAttachmentsUseCase,
    UseCaseInitiateAttachment: InitiateAttachmentUseCase,
    UseCaseCompleteAttachment: CompleteAttachmentUseCase,
    UseCaseUpdateAttachment: UpdateAttachmentUseCase,
    UseCaseDeleteAttachment: DeleteAttachmentUseCase,
    UseCaseGetProductionLinks: GetProductionLinksUseCase,
    UseCaseConfirmProductionLink: ConfirmProductionLinkUseCase,
    UseCaseUnlinkProductionLink: UnlinkProductionLinkUseCase,
    UseCaseRefreshProduction: RefreshProductionUseCase,
}
